.container {
  background-color: var(--tuna-palette-layers);
  transition: width 0.3s;
  z-index: 1;
  border-left: solid 1px var(--tuna-palette-divider);
  transform: translateZ(0);
}

.toolPanel {
  transition: all 0.25s;
  overflow: auto;
  flex: 1;
}

.iconColumn {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.toggleButton {
  border: none;
  border-radius: 0;
  padding: 16px;
}
